// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"gBSeO":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>_Link);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
var _skeleton = require("./Skeleton");
var _utils = require("@react-spectrum/utils");
var _utils1 = require("@react-aria/utils");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    if (props.staticColor === "black") rules += ' db';
    else if (props.staticColor === "white") rules += ' dc';
    else rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _vb';
    rules += ' _wb';
    rules += ' _xb';
    rules += ' _yb';
    if (props.isStandalone) {
        rules += ' _c-bc1l9oh';
        rules += ' _c-1uotwbwg';
        rules += ' _c-eo0c6sf';
        rules += ' _c-enzzrge';
        rules += ' _c-enzykdd';
        rules += ' _c-enzwzjc';
        rules += ' _c-enzrfpb';
        rules += ' _ca';
    }
    if (props.isStandalone) {
        rules += ' _dbf';
        rules += ' _de';
    }
    if (props.isStandalone) rules += ' _ec';
    if (props.isStandalone) {
        rules += ' _f-1x99dlob';
        rules += ' _fa';
    }
    rules += ' aa_____D';
    if (props.staticColor === "black") rules += ' ab';
    else if (props.staticColor === "white") rules += ' ac';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' ao';
        else if (props.isFocusVisible) rules += ' ao';
        else if (props.isHovered) rules += ' ao';
        else rules += ' an';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' az';
        else if (props.isFocusVisible) rules += ' az';
        else if (props.isHovered) rules += ' az';
        else rules += ' ay';
    }
    rules += ' _Oa';
    rules += ' _Q-375x7f';
    rules += ' _Ra';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) rules += ' _la';
            else if (props.isHovered) rules += ' _la';
            else rules += ' _ld';
        }
    } else rules += ' _la';
    rules += ' __R-yksgrp';
    return rules;
};
function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _utils.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _utils1.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
}
/**
 * Links allow users to navigate to a different location.
 * They can be presented inline inside a paragraph or as standalone text.
 */ const _Link = /*#__PURE__*/ (0, _react.forwardRef)(Link);
try {
    // @ts-ignore
    LinkContext.displayName = "LinkContext";
    // @ts-ignore
    LinkContext.__docgenInfo = {
        "description": "",
        "displayName": "LinkContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<LinkProps, FocusableRefValue<HTMLAnchorElement, HTMLAnchorElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Link.tsx#LinkContext"] = {
        docgenInfo: LinkContext.__docgenInfo,
        name: "LinkContext",
        path: "packages/@react-spectrum/s2/src/Link.tsx#LinkContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Link.displayName = "_Link";
    // @ts-ignore
    _Link.__docgenInfo = {
        "description": "Links allow users to navigate to a different location.\nThey can be presented inline inside a paragraph or as standalone text.",
        "displayName": "_Link",
        "props": {
            "autoFocus": {
                "defaultValue": null,
                "description": "Whether the element should receive focus on render.",
                "name": "autoFocus",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "download": {
                "defaultValue": null,
                "description": "Causes the browser to download the linked URL. A string may be provided to suggest a file name. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#download).",
                "name": "download",
                "required": false,
                "type": {
                    "name": "string | boolean"
                }
            },
            "href": {
                "defaultValue": null,
                "description": "A URL to link to. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#href).",
                "name": "href",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "hrefLang": {
                "defaultValue": null,
                "description": "Hints at the human language of the linked URL. See[MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#hreflang).",
                "name": "hrefLang",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "isQuiet": {
                "defaultValue": null,
                "description": "Whether the link should be displayed with a quiet style.",
                "name": "isQuiet",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isStandalone": {
                "defaultValue": null,
                "description": "Whether the link is on its own vs inside a longer string of text.",
                "name": "isStandalone",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "ping": {
                "defaultValue": null,
                "description": "A space-separated list of URLs to ping when the link is followed. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#ping).",
                "name": "ping",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "referrerPolicy": {
                "defaultValue": null,
                "description": "How much of the referrer to send when following the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#referrerpolicy).",
                "name": "referrerPolicy",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"\""
                        },
                        {
                            "value": "\"no-referrer\""
                        },
                        {
                            "value": "\"no-referrer-when-downgrade\""
                        },
                        {
                            "value": "\"origin\""
                        },
                        {
                            "value": "\"origin-when-cross-origin\""
                        },
                        {
                            "value": "\"same-origin\""
                        },
                        {
                            "value": "\"strict-origin\""
                        },
                        {
                            "value": "\"strict-origin-when-cross-origin\""
                        },
                        {
                            "value": "\"unsafe-url\""
                        }
                    ]
                }
            },
            "rel": {
                "defaultValue": null,
                "description": "The relationship between the linked resource and the current page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel).",
                "name": "rel",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "routerOptions": {
                "defaultValue": null,
                "description": "Options for the configured client side router.",
                "name": "routerOptions",
                "required": false,
                "type": {
                    "name": "never"
                }
            },
            "staticColor": {
                "defaultValue": null,
                "description": "The static color style to apply. Useful when the link appears over a color background.",
                "name": "staticColor",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"black\""
                        },
                        {
                            "value": "\"white\""
                        }
                    ]
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "target": {
                "defaultValue": null,
                "description": "The target window for the link. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#target).",
                "name": "target",
                "required": false,
                "type": {
                    "name": "HTMLAttributeAnchorTarget"
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "variant": {
                "defaultValue": {
                    value: "'primary'"
                },
                "description": "The [visual style](https://spectrum.adobe.com/page/link/#Options) of the link.",
                "name": "variant",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"primary\""
                        },
                        {
                            "value": "\"secondary\""
                        }
                    ]
                }
            },
            "onPress": {
                "defaultValue": null,
                "description": "Handler that is called when the press is released over the target.",
                "name": "onPress",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressChange": {
                "defaultValue": null,
                "description": "Handler that is called when the press state changes.",
                "name": "onPressChange",
                "required": false,
                "type": {
                    "name": "(isPressed: boolean) => void"
                }
            },
            "onPressEnd": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction ends, either\nover the target or when the pointer leaves the target.",
                "name": "onPressEnd",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressStart": {
                "defaultValue": null,
                "description": "Handler that is called when a press interaction starts.",
                "name": "onPressStart",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "onPressUp": {
                "defaultValue": null,
                "description": "Handler that is called when a press is released over the target, regardless of\nwhether it started on the target or not.",
                "name": "onPressUp",
                "required": false,
                "type": {
                    "name": "(e: PressEvent) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLAnchorElement, HTMLAnchorElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Link.tsx#_Link"] = {
        docgenInfo: _Link.__docgenInfo,
        name: "_Link",
        path: "packages/@react-spectrum/s2/src/Link.tsx#_Link"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"b9eBP","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","react":"jEiK2","./Skeleton":"2hWWB","@react-spectrum/utils":"bebxO","@react-aria/utils":"e9Yvo","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"b9eBP":[function() {},{}],"i5lSP":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderContext", ()=>SliderContext);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "thumbContainer", ()=>thumbContainer);
parcelHelpers.export(exports, "thumbHitArea", ()=>thumbHitArea);
parcelHelpers.export(exports, "thumb", ()=>thumb);
parcelHelpers.export(exports, "upperTrack", ()=>upperTrack);
parcelHelpers.export(exports, "filledTrack", ()=>filledTrack);
parcelHelpers.export(exports, "SliderBase", ()=>SliderBase);
parcelHelpers.export(exports, "Slider", ()=>_Slider);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _field = require("./Field");
var _form = require("./Form");
var _runtime = require("../style/runtime");
var _pressScale = require("./pressScale");
var _utils1 = require("@react-spectrum/utils");
var _i18N = require("@react-aria/i18n");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const SliderContext = /*#__PURE__*/ (0, _react.createContext)(null);
const slider = function anonymous(props, overrides) {
    let rules = " .";
    let matches = (overrides || '').match(/(?:^|\s)(?:y|z|A|B|_9|_8|h|_5|_4|__A|__c|__d|__a|__b|U|__Q|X|Z|V|W|l|q|r)[^\s]+/g) || [];
    rules += matches.join('');
    rules += ' _c-bc1l9oh';
    rules += ' _c-1uotwbwg';
    rules += ' _c-eo0c6sf';
    rules += ' _c-enzzrge';
    rules += ' _c-enzykdd';
    rules += ' _c-enzwzjc';
    rules += ' _c-enzrfpb';
    rules += ' _ca';
    if (props.size === "XL") {
        rules += ' _dbj';
        rules += ' _di';
    } else if (props.size === "L") {
        rules += ' _dbh';
        rules += ' _dg';
    } else if (props.size === "S") {
        rules += ' _dbd';
        rules += ' _dc';
    } else if (props.size === "XS") {
        rules += ' _dbb';
        rules += ' _da';
    } else {
        rules += ' _dbf';
        rules += ' _de';
    }
    rules += ' _eb';
    rules += ' _f-1x99dlob';
    rules += ' _fa';
    if (props.isDisabled) rules += ' aj';
    else {
        if (props.isPressed) rules += ' an';
        else if (props.isFocusVisible) rules += ' an';
        else if (props.isHovered) rules += ' an';
        else rules += ' am';
    }
    if (props.labelPosition === "side") rules += ' _1c';
    if (props.isInForm) rules += ' je';
    else if (props.size === "XL") rules += ' jh';
    else if (props.size === "L") rules += ' jg';
    else if (props.size === "M") rules += ' jf';
    else if (props.size === "S") rules += ' jf';
    return rules;
};
const labelContainer = function anonymous(props) {
    let rules = " .";
    if (props.labelPosition === "top") rules += ' _Zf';
    rules += ' __a-4e9m05';
    rules += ' __b-4e9m05';
    rules += ' __c-4e9m05';
    rules += ' __d-4e9m05';
    rules += ' l4';
    if (props.labelPosition === "top") rules += ' __j-qdp51y';
    if (props.labelPosition === "top") rules += ' __h-u2tns7';
    if (props.labelPosition === "side") {
        if (props.labelAlign === "end") rules += ' _jc';
        else if (props.labelAlign === "start") rules += ' _ja';
    }
    rules += ' -_1inj1bc_F-a';
    return rules;
};
const output = function anonymous(props) {
    let rules = " .";
    rules += ' __a-5czzau';
    rules += ' __b-5czzau';
    rules += ' __c-5czzau';
    rules += ' __d-5czzau';
    if (props.labelPosition === "side") {
        if (props.isInForm) rules += ' _jc';
        else if (props.direction === "rtl") rules += ' _jc';
        else if (props.direction === "ltr") rules += ' _ja';
    } else if (props.labelPosition === "top") {
        if (props.direction === "rtl") rules += ' _ja';
        else if (props.direction === "ltr") rules += ' _jc';
    }
    return rules;
};
let track = function anonymous(props) {
    let rules = " .";
    rules += ' __a-4ka10a';
    rules += ' __b-4ka10a';
    rules += ' __c-4ka10a';
    rules += ' __d-4ka10a';
    if (props.size === "XL") {
        rules += ' qby';
        rules += ' qx';
    } else if (props.size === "L") {
        rules += ' qbu';
        rules += ' qr';
    } else if (props.size === "S") {
        rules += ' qbn';
        rules += ' qm';
    } else if (props.size === "XS") {
        rules += ' qbl';
        rules += ' qk';
    } else {
        rules += ' qbr';
        rules += ' qq';
    }
    if (props.isQuiet) rules += ' __ma';
    else rules += ' __m-1s8glxue';
    if (props.size === "XL") {
        rules += ' -usygro_l-bV';
        rules += ' -usygro_l-Q';
    } else if (props.size === "L") {
        rules += ' -usygro_l-bU';
        rules += ' -usygro_l-T';
    } else if (props.size === "S") {
        rules += ' -usygro_l-bQ';
        rules += ' -usygro_l-P';
    } else {
        rules += ' -usygro_l-bS';
        rules += ' -usygro_l-R';
    }
    rules += ' m-rwozxi';
    rules += ' Uc';
    rules += ' l4';
    if (props.size === "XL") {
        rules += ' kby';
        rules += ' kx';
    } else if (props.size === "L") {
        rules += ' kbu';
        rules += ' kr';
    } else if (props.size === "M") {
        rules += ' kbr';
        rules += ' kq';
    } else if (props.size === "S") {
        rules += ' kbn';
        rules += ' km';
    }
    return rules;
};
let thumbContainer = function anonymous(props) {
    let rules = " .";
    if (props.size === "XL") {
        rules += ' lbn';
        rules += ' lm';
    } else if (props.size === "L") {
        rules += ' lb-1u8pit0';
        rules += ' l-16cidj';
    } else if (props.size === "M") {
        rules += ' lbl';
        rules += ' lk';
    } else if (props.size === "S") {
        rules += ' lb-1nxaedl';
        rules += ' l-1ytbuww';
    }
    if (props.size === "XL") {
        rules += ' kbn';
        rules += ' km';
    } else if (props.size === "L") {
        rules += ' kb-1u8pit0';
        rules += ' k-16cidj';
    } else if (props.size === "M") {
        rules += ' kbl';
        rules += ' kk';
    } else if (props.size === "S") {
        rules += ' kb-1nxaedl';
        rules += ' k-1ytbuww';
    }
    rules += ' _Zb';
    rules += ' Ua';
    rules += ' X-3760fj';
    return rules;
};
let thumbHitArea = function anonymous(props) {
    let rules = " .";
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") {
            rules += ' lb-1qh0xw';
            rules += ' l-30pu91';
        } else if (props.size === "L") {
            rules += ' lbn';
            rules += ' lm';
        } else if (props.size === "M") {
            rules += ' lb-1u8pit0';
            rules += ' l-16cidj';
        } else if (props.size === "S") {
            rules += ' lbl';
            rules += ' lk';
        }
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") {
            rules += ' lbn';
            rules += ' lm';
        } else if (props.size === "L") {
            rules += ' lb-1u8pit0';
            rules += ' l-16cidj';
        } else if (props.size === "M") {
            rules += ' lbl';
            rules += ' lk';
        } else if (props.size === "S") {
            rules += ' lb-1nxaedl';
            rules += ' l-1ytbuww';
        }
    }
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") {
            rules += ' kb-1qh0xw';
            rules += ' k-30pu91';
        } else if (props.size === "L") {
            rules += ' kbn';
            rules += ' km';
        } else if (props.size === "M") {
            rules += ' kb-1u8pit0';
            rules += ' k-16cidj';
        } else if (props.size === "S") {
            rules += ' kbl';
            rules += ' kk';
        }
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") {
            rules += ' kbn';
            rules += ' km';
        } else if (props.size === "L") {
            rules += ' kb-1u8pit0';
            rules += ' k-16cidj';
        } else if (props.size === "M") {
            rules += ' kbl';
            rules += ' kk';
        } else if (props.size === "S") {
            rules += ' kb-1nxaedl';
            rules += ' k-1ytbuww';
        }
    }
    return rules;
};
let thumb = function anonymous(props) {
    let rules = " .";
    if (props.isFocusVisible) rules += ' _Lb';
    else rules += ' _La';
    rules += ' da_____z';
    rules += ' dx';
    rules += ' _Nc';
    rules += ' _M-3t1z';
    rules += ' _Zb';
    rules += ' __na';
    rules += ' Ua';
    rules += ' X-3760fj';
    rules += ' Y-3760fj';
    rules += ' T-s83jgi';
    if (props.thumbStyle === "precise") {
        rules += ' lb-1aa9md1';
        rules += ' l-6njx2e';
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") {
            rules += ' lbn';
            rules += ' lm';
        } else if (props.size === "L") {
            rules += ' lb-1u8pit0';
            rules += ' l-16cidj';
        } else if (props.size === "M") {
            rules += ' lbl';
            rules += ' lk';
        } else if (props.size === "S") {
            rules += ' lb-1nxaedl';
            rules += ' l-1ytbuww';
        }
    }
    if (props.thumbStyle === "precise") {
        if (props.size === "XL") {
            rules += ' kb-1qh0xw';
            rules += ' k-30pu91';
        } else if (props.size === "L") {
            rules += ' kbn';
            rules += ' km';
        } else if (props.size === "M") {
            rules += ' kb-1u8pit0';
            rules += ' k-16cidj';
        } else if (props.size === "S") {
            rules += ' kbl';
            rules += ' kk';
        }
    } else if (props.thumbStyle === "default") {
        if (props.size === "XL") {
            rules += ' kbn';
            rules += ' km';
        } else if (props.size === "L") {
            rules += ' kb-1u8pit0';
            rules += ' k-16cidj';
        } else if (props.size === "M") {
            rules += ' kbl';
            rules += ' kk';
        } else if (props.size === "S") {
            rules += ' kb-1nxaedl';
            rules += ' k-1ytbuww';
        }
    }
    rules += ' _vf';
    rules += ' _wf';
    rules += ' _xf';
    rules += ' _yf';
    rules += ' wa';
    rules += ' u-375zlr';
    rules += ' v-375zlr';
    rules += ' s-375zlr';
    rules += ' t-375zlr';
    if (props.isDisabled) rules += ' ca_____B';
    if (props.isDisabled) rules += ' ci';
    else if (props.isDragging) rules += ' co';
    else if (props.isHovered) rules += ' co';
    else rules += ' cn';
    rules += ' bd';
    return rules;
};
const trackStyling = {
    height: {
        trackStyle: {
            thin: 4,
            thick: 16
        }
    },
    top: '[50%]',
    borderRadius: {
        trackStyle: {
            thin: 'lg',
            thick: 'sm'
        }
    }
};
let upperTrack = function anonymous(props) {
    let rules = " .";
    if (props.trackStyle === "thick") {
        rules += ' kbk';
        rules += ' kj';
    } else if (props.trackStyle === "thin") {
        rules += ' kbe';
        rules += ' kd';
    }
    rules += ' X-3760fj';
    if (props.trackStyle === "thick") rules += ' _vb';
    else if (props.trackStyle === "thin") rules += ' _vd';
    if (props.trackStyle === "thick") rules += ' _wb';
    else if (props.trackStyle === "thin") rules += ' _wd';
    if (props.trackStyle === "thick") rules += ' _xb';
    else if (props.trackStyle === "thin") rules += ' _xd';
    if (props.trackStyle === "thick") rules += ' _yb';
    else if (props.trackStyle === "thin") rules += ' _yd';
    rules += ' Ua';
    if (props.isDisabled) rules += ' bg';
    else rules += ' bi';
    rules += ' Q-yj8axo';
    rules += ' l4';
    rules += ' __na';
    rules += ' wa';
    rules += ' u-yj94cw';
    rules += ' v-yj94cw';
    rules += ' s-yj94cw';
    rules += ' t-yj94cw';
    if (props.isDisabled) rules += ' ca_____B';
    else rules += ' ca_____x';
    rules += ' ca';
    return rules;
};
let filledTrack = function anonymous(props) {
    let rules = " .";
    if (props.trackStyle === "thick") {
        rules += ' kbk';
        rules += ' kj';
    } else if (props.trackStyle === "thin") {
        rules += ' kbe';
        rules += ' kd';
    }
    rules += ' X-3760fj';
    if (props.trackStyle === "thick") rules += ' _vb';
    else if (props.trackStyle === "thin") rules += ' _vd';
    if (props.trackStyle === "thick") rules += ' _wb';
    else if (props.trackStyle === "thin") rules += ' _wd';
    if (props.trackStyle === "thick") rules += ' _xb';
    else if (props.trackStyle === "thin") rules += ' _xd';
    if (props.trackStyle === "thick") rules += ' _yb';
    else if (props.trackStyle === "thin") rules += ' _yd';
    rules += ' Ua';
    if (props.isDisabled) rules += ' ba_____B';
    else rules += ' ba_____z';
    if (props.isDisabled) rules += ' bg';
    else if (props.isEmphasized) rules += ' by';
    else rules += ' bm';
    rules += ' __na';
    rules += ' wa';
    rules += ' u-yj94cw';
    rules += ' v-yj94cw';
    rules += ' s-yj94cw';
    rules += ' t-yj94cw';
    if (props.isDisabled) rules += ' ca_____B';
    else rules += ' ca_____x';
    rules += ' ca';
    rules += ' Q-yj8axo';
    return rules;
};
function SliderBase(props1) {
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props1 = (0, _form.useFormProps)(props1);
    let { label, labelPosition = 'top', labelAlign = 'start', size = 'M', minValue = 0, maxValue = 100, formatOptions } = props1;
    let formatter = (0, _i18N.useNumberFormatter)(formatOptions);
    let { direction } = (0, _i18N.useLocale)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Slider), {
        ...props1,
        ref: props1.sliderRef,
        className: (renderProps)=>(props1.UNSAFE_className || '') + (0, _runtime.mergeStyles)(function anonymous(props) {
                let rules = " .";
                rules += ' _Zf';
                if (props.isInForm) rules += ' __a-3t1y';
                if (props.isInForm) {
                    if (props.labelPosition === "side") rules += ' __b-7u9dhl';
                }
                if (props.isInForm) rules += ' __h-1cwd7ud';
                else {
                    if (props.labelPosition === "side") rules += ' __h-jyg4vb';
                    else if (props.labelPosition === "top") rules += ' __h-375yi6';
                }
                if (props.labelPosition === "side") rules += ' __i-jyg4vb';
                else if (props.labelPosition === "top") rules += ' __i-fdenls';
                if (props.labelPosition === "side") rules += ' __j-5eez8j';
                else if (props.labelPosition === "top") rules += ' __j-xlaqir';
                if (props.size === "XL") {
                    rules += ' _dbj';
                    rules += ' _di';
                } else if (props.size === "L") {
                    rules += ' _dbh';
                    rules += ' _dg';
                } else if (props.size === "S") {
                    rules += ' _dbd';
                    rules += ' _dc';
                } else if (props.size === "XS") {
                    rules += ' _dbb';
                    rules += ' _da';
                } else {
                    rules += ' _dbf';
                    rules += ' _de';
                }
                rules += ' _1d';
                rules += ' _f-1x99dlob';
                rules += ' _fa';
                if (props.size === "XL") {
                    rules += ' -aqrvqh_k-by';
                    rules += ' -aqrvqh_k-x';
                } else if (props.size === "L") {
                    rules += ' -aqrvqh_k-bu';
                    rules += ' -aqrvqh_k-r';
                } else if (props.size === "S") {
                    rules += ' -aqrvqh_k-bn';
                    rules += ' -aqrvqh_k-m';
                } else if (props.size === "XS") {
                    rules += ' -aqrvqh_k-bl';
                    rules += ' -aqrvqh_k-k';
                } else {
                    rules += ' -aqrvqh_k-br';
                    rules += ' -aqrvqh_k-q';
                }
                rules += ' -_1inj1bc_i--prjw07';
                rules += ' je';
                rules += ' __R-yksgrp';
                return rules;
            }({
                labelPosition,
                isInForm: !!formContext
            }), slider({
                ...renderProps,
                labelPosition,
                size,
                isInForm: !!formContext
            }, props1.styles)),
        children: ({ state })=>{
            let maxLabelLength = Math.max([
                ...formatter.format(minValue)
            ].length, [
                ...formatter.format(maxValue)
            ].length);
            switch(state.values.length){
                case 1:
                    break;
                case 2:
                    // This should really use the NumberFormat#formatRange proposal...
                    // https://github.com/tc39/ecma402/issues/393
                    // https://github.com/tc39/proposal-intl-numberformat-v3#formatrange-ecma-402-393
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatRange
                    maxLabelLength = 3 + 2 * Math.max(maxLabelLength, [
                        ...formatter.format(minValue)
                    ].length, [
                        ...formatter.format(maxValue)
                    ].length);
                    break;
                default:
                    throw new Error('Only sliders with 1 or 2 handles are supported!');
            }
            let outputValue = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderOutput), {
                style: {
                    width: `${maxLabelLength}ch`,
                    minWidth: `${maxLabelLength}ch`,
                    fontVariantNumeric: 'tabular-nums'
                },
                className: output({
                    direction,
                    labelPosition,
                    isInForm: !!formContext
                }),
                children: ({ state })=>state.values.map((_, i)=>state.getThumbValueLabel(i)).join(" \u2013 ")
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: labelContainer({
                            labelPosition,
                            labelAlign
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _field.FieldLabel), {
                                isDisabled: props1.isDisabled,
                                size: props1.size,
                                labelPosition: labelPosition,
                                labelAlign: labelAlign,
                                contextualHelp: props1.contextualHelp,
                                children: label
                            }),
                            labelPosition === 'top' && outputValue
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: function anonymous(props) {
                            let rules = " .";
                            rules += ' __a-4cfph1';
                            rules += ' __b-4cfph1';
                            rules += ' __c-4cfph1';
                            rules += ' __d-4cfph1';
                            rules += ' _Ze';
                            rules += ' _1c';
                            if (props.size === "XL") rules += ' ih';
                            else if (props.size === "L") rules += ' ig';
                            else rules += ' if';
                            if (props.size === "XL") rules += ' jh';
                            else if (props.size === "L") rules += ' jg';
                            else rules += ' jf';
                            return rules;
                        }({
                            size
                        }),
                        children: [
                            props1.children,
                            labelPosition === 'side' && outputValue
                        ]
                    })
                ]
            });
        }
    });
}
function Slider(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, SliderContext);
    let formContext = (0, _react.useContext)((0, _form.FormContext));
    props = (0, _form.useFormProps)(props);
    let { labelPosition = 'top', size = 'M', fillOffset, isEmphasized, trackStyle = 'thin', thumbStyle = 'default' } = props;
    let thumbRef = (0, _react.useRef)(null);
    let inputRef = (0, _react.useRef)(null); // TODO: need to pass inputRef to SliderThumb when we release the next version of RAC 1.3.0
    let domRef = (0, _utils1.useFocusableRef)(ref, inputRef);
    let { direction } = (0, _i18N.useLocale)();
    let cssDirection = direction === 'rtl' ? 'right' : 'left';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SliderBase, {
        ...props,
        sliderRef: domRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderTrack), {
            className: track({
                size,
                labelPosition,
                isInForm: !!formContext
            }),
            children: ({ state, isDisabled })=>{
                fillOffset = fillOffset !== undefined ? (0, _utils.clamp)(fillOffset, state.getThumbMinValue(0), state.getThumbMaxValue(0)) : 0;
                let fillWidth = state.getThumbPercent(0) - state.getValuePercent(fillOffset);
                let isRightOfOffset = fillWidth > 0;
                let offset = isRightOfOffset ? state.getValuePercent(fillOffset) : state.getThumbPercent(0);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: upperTrack({
                                isDisabled,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                width: `${Math.abs(fillWidth) * 100}%`,
                                [cssDirection]: `${offset * 100}%`
                            },
                            className: filledTrack({
                                isDisabled,
                                isEmphasized,
                                trackStyle
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SliderThumb), {
                            className: thumbContainer,
                            index: 0,
                            name: props.name,
                            ref: thumbRef,
                            style: (renderProps)=>(0, _pressScale.pressScale)(thumbRef, {
                                    transform: 'translate(-50%, -50%)'
                                })({
                                    ...renderProps,
                                    isPressed: renderProps.isDragging
                                }),
                            children: (renderProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: thumbHitArea({
                                        size
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: thumb({
                                            ...renderProps,
                                            size,
                                            thumbStyle
                                        })
                                    })
                                })
                        })
                    ]
                });
            }
        })
    });
}
let _Slider = /*#__PURE__*/ (0, _react.forwardRef)(Slider);
try {
    // @ts-ignore
    SliderBase.displayName = "SliderBase";
    // @ts-ignore
    SliderBase.__docgenInfo = {
        "description": "",
        "displayName": "SliderBase",
        "props": {
            "sliderRef": {
                "defaultValue": null,
                "description": "",
                "name": "sliderRef",
                "required": true,
                "type": {
                    "name": "RefObject<HTMLDivElement>"
                }
            },
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "number | number[]"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the whole Slider is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Slider should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The slider's maximum value.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The slider's minimum value.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Slider.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "step": {
                "defaultValue": {
                    value: "1"
                },
                "description": "The slider's step value.",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "thumbStyle": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The style of the Slider's thumb.",
                "name": "thumbStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"precise\""
                        }
                    ]
                }
            },
            "trackStyle": {
                "defaultValue": {
                    value: "'thin'"
                },
                "description": "The style of the Slider's track.",
                "name": "trackStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"thin\""
                        },
                        {
                            "value": "\"thick\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number | number[]"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "(value: T) => void"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Fired when the slider stops moving, due to being let go.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "(value: T) => void"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#SliderBase"] = {
        docgenInfo: SliderBase.__docgenInfo,
        name: "SliderBase",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#SliderBase"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    SliderContext.displayName = "SliderContext";
    // @ts-ignore
    SliderContext.__docgenInfo = {
        "description": "",
        "displayName": "SliderContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<SliderProps, FocusableRefValue<HTMLDivElement, HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#SliderContext"] = {
        docgenInfo: SliderContext.__docgenInfo,
        name: "SliderContext",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#SliderContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    track.displayName = "track";
    // @ts-ignore
    track.__docgenInfo = {
        "description": "",
        "displayName": "track",
        "props": {
            "isQuiet": {
                "defaultValue": null,
                "description": "",
                "name": "isQuiet",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#track"] = {
        docgenInfo: track.__docgenInfo,
        name: "track",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#track"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    thumbContainer.displayName = "thumbContainer";
    // @ts-ignore
    thumbContainer.__docgenInfo = {
        "description": "",
        "displayName": "thumbContainer",
        "props": {
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#thumbContainer"] = {
        docgenInfo: thumbContainer.__docgenInfo,
        name: "thumbContainer",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#thumbContainer"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    thumbHitArea.displayName = "thumbHitArea";
    // @ts-ignore
    thumbHitArea.__docgenInfo = {
        "description": "",
        "displayName": "thumbHitArea",
        "props": {
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "thumbStyle": {
                "defaultValue": null,
                "description": "",
                "name": "thumbStyle",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#thumbHitArea"] = {
        docgenInfo: thumbHitArea.__docgenInfo,
        name: "thumbHitArea",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#thumbHitArea"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    thumb.displayName = "thumb";
    // @ts-ignore
    thumb.__docgenInfo = {
        "description": "",
        "displayName": "thumb",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isDragging": {
                "defaultValue": null,
                "description": "",
                "name": "isDragging",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isFocusVisible": {
                "defaultValue": null,
                "description": "",
                "name": "isFocusVisible",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isHovered": {
                "defaultValue": null,
                "description": "",
                "name": "isHovered",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "size": {
                "defaultValue": null,
                "description": "",
                "name": "size",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "thumbStyle": {
                "defaultValue": null,
                "description": "",
                "name": "thumbStyle",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#thumb"] = {
        docgenInfo: thumb.__docgenInfo,
        name: "thumb",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#thumb"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    upperTrack.displayName = "upperTrack";
    // @ts-ignore
    upperTrack.__docgenInfo = {
        "description": "",
        "displayName": "upperTrack",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "trackStyle": {
                "defaultValue": null,
                "description": "",
                "name": "trackStyle",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#upperTrack"] = {
        docgenInfo: upperTrack.__docgenInfo,
        name: "upperTrack",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#upperTrack"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    filledTrack.displayName = "filledTrack";
    // @ts-ignore
    filledTrack.__docgenInfo = {
        "description": "",
        "displayName": "filledTrack",
        "props": {
            "isDisabled": {
                "defaultValue": null,
                "description": "",
                "name": "isDisabled",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "",
                "name": "isEmphasized",
                "required": true,
                "type": {
                    "name": "any"
                }
            },
            "trackStyle": {
                "defaultValue": null,
                "description": "",
                "name": "trackStyle",
                "required": true,
                "type": {
                    "name": "any"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#filledTrack"] = {
        docgenInfo: filledTrack.__docgenInfo,
        name: "filledTrack",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#filledTrack"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    _Slider.displayName = "_Slider";
    // @ts-ignore
    _Slider.__docgenInfo = {
        "description": "",
        "displayName": "_Slider",
        "props": {
            "contextualHelp": {
                "defaultValue": null,
                "description": "A ContextualHelp element to place next to the label.",
                "name": "contextualHelp",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "defaultValue": {
                "defaultValue": null,
                "description": "The default value (uncontrolled).",
                "name": "defaultValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "fillOffset": {
                "defaultValue": null,
                "description": "The offset from which to start the fill.",
                "name": "fillOffset",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "formatOptions": {
                "defaultValue": null,
                "description": "The display format of the value label.",
                "name": "formatOptions",
                "required": false,
                "type": {
                    "name": "NumberFormatOptions"
                }
            },
            "isDisabled": {
                "defaultValue": null,
                "description": "Whether the whole Slider is disabled.",
                "name": "isDisabled",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "isEmphasized": {
                "defaultValue": null,
                "description": "Whether the Slider should be displayed with an emphasized style.",
                "name": "isEmphasized",
                "required": false,
                "type": {
                    "name": "boolean"
                }
            },
            "label": {
                "defaultValue": null,
                "description": "The content to display as the label.",
                "name": "label",
                "required": false,
                "type": {
                    "name": "ReactNode"
                }
            },
            "labelAlign": {
                "defaultValue": {
                    value: "'start'"
                },
                "description": "The label's horizontal alignment relative to the element it is labeling.",
                "name": "labelAlign",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"start\""
                        },
                        {
                            "value": "\"end\""
                        }
                    ]
                }
            },
            "labelPosition": {
                "defaultValue": {
                    value: "'top'"
                },
                "description": "The label's overall position relative to the element it is labeling.",
                "name": "labelPosition",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"top\""
                        },
                        {
                            "value": "\"side\""
                        }
                    ]
                }
            },
            "maxValue": {
                "defaultValue": {
                    value: "100"
                },
                "description": "The slider's maximum value.",
                "name": "maxValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "minValue": {
                "defaultValue": {
                    value: "0"
                },
                "description": "The slider's minimum value.",
                "name": "minValue",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "name": {
                "defaultValue": null,
                "description": "The name of the input element, used when submitting an HTML form. See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#htmlattrdefname).",
                "name": "name",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "size": {
                "defaultValue": {
                    value: "'M'"
                },
                "description": "The size of the Slider.",
                "name": "size",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"S\""
                        },
                        {
                            "value": "\"M\""
                        },
                        {
                            "value": "\"L\""
                        },
                        {
                            "value": "\"XL\""
                        }
                    ]
                }
            },
            "step": {
                "defaultValue": {
                    value: "1"
                },
                "description": "The slider's step value.",
                "name": "step",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "styles": {
                "defaultValue": null,
                "description": "Spectrum-defined styles, returned by the `style()` macro.",
                "name": "styles",
                "required": false,
                "type": {
                    "name": "StylesProp"
                }
            },
            "thumbStyle": {
                "defaultValue": {
                    value: "'default'"
                },
                "description": "The style of the Slider's thumb.",
                "name": "thumbStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"default\""
                        },
                        {
                            "value": "\"precise\""
                        }
                    ]
                }
            },
            "trackStyle": {
                "defaultValue": {
                    value: "'thin'"
                },
                "description": "The style of the Slider's track.",
                "name": "trackStyle",
                "required": false,
                "type": {
                    "name": "enum",
                    "value": [
                        {
                            "value": "\"thin\""
                        },
                        {
                            "value": "\"thick\""
                        }
                    ]
                }
            },
            "UNSAFE_className": {
                "defaultValue": null,
                "description": "Sets the CSS [className](https://developer.mozilla.org/en-US/docs/Web/API/Element/className) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_className",
                "required": false,
                "type": {
                    "name": "string"
                }
            },
            "UNSAFE_style": {
                "defaultValue": null,
                "description": "Sets inline [style](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style) for the element. Only use as a **last resort**. Use the `style` macro via the `styles` prop instead.",
                "name": "UNSAFE_style",
                "required": false,
                "type": {
                    "name": "CSSProperties"
                }
            },
            "value": {
                "defaultValue": null,
                "description": "The current value (controlled).",
                "name": "value",
                "required": false,
                "type": {
                    "name": "number"
                }
            },
            "onChange": {
                "defaultValue": null,
                "description": "Handler that is called when the value changes.",
                "name": "onChange",
                "required": false,
                "type": {
                    "name": "(value: number) => void"
                }
            },
            "onChangeEnd": {
                "defaultValue": null,
                "description": "Fired when the slider stops moving, due to being let go.",
                "name": "onChangeEnd",
                "required": false,
                "type": {
                    "name": "(value: number) => void"
                }
            },
            "key": {
                "defaultValue": null,
                "description": "",
                "name": "key",
                "required": false,
                "type": {
                    "name": "Key"
                }
            },
            "ref": {
                "defaultValue": null,
                "description": "Allows getting a ref to the component instance.\nOnce the component unmounts, React will set `ref.current` to `null`\n(or call the ref with `null` if you passed a callback ref).\n@see {@link https://react.dev/learn/referencing-values-with-refs#refs-and-the-dom React Docs}",
                "name": "ref",
                "required": false,
                "type": {
                    "name": "Ref<FocusableRefValue<HTMLDivElement, HTMLDivElement>>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Slider.tsx#_Slider"] = {
        docgenInfo: _Slider.__docgenInfo,
        name: "_Slider",
        path: "packages/@react-spectrum/s2/src/Slider.tsx#_Slider"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"4cDR9","1":"dZxZ1","2":"bJkdU","3":"5O0ob","4":"gYawQ","5":"4VMGS","6":"6qBQ4","7":"iUwMV","8":"1niXA","9":"jcVpa","10":"aYVTU","react/jsx-runtime":"2JzhG","react-aria-components":"8nuKL","@react-aria/utils":"e9Yvo","react":"jEiK2","./Field":"9c1qW","./Form":"gJckc","../style/runtime":"dzhKB","./pressScale":"6BiUY","@react-spectrum/utils":"bebxO","@react-aria/i18n":"hFrKJ","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"4cDR9":[function() {},{}],"dZxZ1":[function() {},{}],"bJkdU":[function() {},{}],"5O0ob":[function() {},{}],"gYawQ":[function() {},{}],"4VMGS":[function() {},{}],"6qBQ4":[function() {},{}],"iUwMV":[function() {},{}],"1niXA":[function() {},{}],"jcVpa":[function() {},{}],"aYVTU":[function() {},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.802c6ca8.js.map
